
import Barcode from 'react-barcode';
import Custombarcode from './components/barcode';
import { templateMock } from './constant';

const PdfTemplate10 = ({ data, userInfo }: any) => {
  const renderData = data || templateMock;

  return (
    <>
      {renderData &&
        renderData.map((item: any) => (
          <div className="templates  [&>div]:text-[6pt]  flex flex-col   w-[5.5cm] h-[5cm]  " style={{ pageBreakInside: 'avoid' }}>
            <div className="flex flex-col items-center  p-4  rounded-lg ">
              <div className="flex w-full gap-2 ">
                {' '}
                <p>نام گیرنده:</p> <p>{item.receiverProspectName}</p>
              </div>
              <div className="flex w-full gap-2 mb-2">
                {' '}
                <p className="whitespace-nowrap">آدرس گیرنده:</p> <p className="break-words"> {item.receiverAddress}</p>
              </div>
              {/* خطوط بارکد */}
              {!!data ? (
                <>
                  <div className=" scale-[.55] mt-[-20px]">
                    <Barcode width={2} height={60} value={item.cprNumber} displayValue={true} />
                  </div>
                  <p className=" mt-[-1rem]">باکسیت</p>
                </>
              ) : (
                <>
                  <Custombarcode />
                  <p className=" ">باکسیت</p>
                </>
              )}
            </div>
          </div>
        ))}

      <style>{`
            @media print {
              @page {
                size: 5.5cm 5cm;
                  
              }   
            }
            `}</style>
    </>
  );
};

export default PdfTemplate10;
